/**
 * `496691` — the **Emails & Activities** app's cross-board creator: *create an
 * {item, itemMapping} in {this board, linkageBoards} and connect it to the source item*
 * (recipe 30508885, 1 automation on this account).
 *
 * Registered so the automation imports with its configuration intact, **not executable**: its
 * mapping reads activity fields — `source_item`, `activityType`, `person` (activity creator),
 * `endDate` — that belong to monday's Emails & Activities CRM object, which this product does
 * not have and which no capture describes. Its trigger (`496714`, "when activity is created in
 * Emails & Activities") is likewise absent, so the recipe stays `unmapped` rather than
 * pretending to be runnable; `specs/M6-A4-integrations.md` §9 lists it with the two monday-AI
 * blocks as the deliberate gaps.
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
import { itemMappingSchema } from '../item-mapping.js';
import { numberish } from '../values.js';
export const activityCreateItemParams = z.object({
    targetBoardId: numberish.nullable().optional(),
    linkageBoards: z.unknown().optional(),
    itemMapping: itemMappingSchema,
});
export const activityCreateItemAction = defineAction({
    id: '496691',
    kind: 'action',
    app: 'apps',
    sentencePartial: 'create an {item, itemMapping} in {this board, linkageBoards} and connect it to the source item',
    paramsSchema: activityCreateItemParams,
    executable: false,
    assumed: true,
    requiredApp: 'emails-activities',
    references: () => [],
    execute: () => Promise.resolve({ skipped: 'block_unavailable' }),
});
//# sourceMappingURL=496691.js.map